<!--
 * @Author: DY
 * @Date: 2021-03-19 10:58:16
 * @LastEditTime: 2022-02-17 15:02:02
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \JT_Web_test\src\components\businessInstance\selectionNode\index_new.vue
-->
<template>
    <div class="selectionNode_new" v-loading="loading">
        <div class="selectionNodeContent">
            <div class="processNode">
                <h5>流程节点</h5>
                <ul>
                    <template v-for="(item, index) in nodeData">
                        <li
                            :class="{'active': currentNode == index, 'countersignatureNode':item.node_type == 3}"
                            :key="index"
                            @click="selectNode(index, item, 'commonNode')"
                        >
                            <span v-if="item.ApproverType == 1">
                                查看
                                <i class="iconfont iconshuangyoujiantou-"></i>
                            </span>
                            <span v-else>
                                选择
                                <i class="iconfont iconshuangyoujiantou-"></i>
                            </span>
                            <span v-if="item.data[0].IsHandled" class="isApproved">
                                已办
                            </span>
                            <p
                                v-if="item.node_type == 3"
                                class="iconfont icon05qunzufill"
                            >
                                会签审核
                            </p>
                            <p v-else>
                                {{ item.data[0].BusinessPhaseName }}
                            </p>
                        </li>
                    </template>
                </ul>
            </div>
            <div class="linkPersonnel" :class="{'isCountersignatureNode': nodeType == 3}">
                <div class="link" v-if="nodeType == 3">
                    <div class="btns">
                        <el-button size="mini" class="iconfont iconjiantouzuo" @click="countersignNode_left"></el-button>
                        <el-button size="mini" class="iconfont iconjiantouyou" @click="countersignNode_right"></el-button>
                    </div>
                    <div class="linkBox">
                        <ul>
                            <template v-for="(item, index) in countersignNodeData">
                                <li
                                    :key="index"
                                    :class="{'active': countersignNodeIndex == index}"
                                    @click="selectNode(index, item, 'countersignatureNode')"
                                >
                                    <h3>
                                        <i v-if="item.IsRequired == 1">*</i>
                                        {{ item.BusinessPhaseName }}
                                    </h3>
                                    <p>
                                        已选：
                                        <template v-for="(k,i) in item.ApproverName">
                                            <span :key="i" v-if="i < 3">{{ k }}</span>
                                        </template>
                                    </p>
                                </li>
                            </template>
                        </ul>
                    </div>
                </div>
                <div class="personnel">
                    <template v-if="nodeReturnData.IsCrossHierarchy == false">
                        <div class="choseMembers" v-if="nodeApproverCategory == 2 && !isBack">
                            <div class="contant">
                                <div class="search iconfont iconsousuo">
                                    <el-input placeholder="请输入待选人员名称" v-model="queryCriteria" @change="query"></el-input>
                                </div>
                                <div class="clearfix createTeamCon">
                                    <div class="role el_left">
                                        <div class="tit">
                                            角色
                                        </div>
                                        <ul>
                                            <template v-for="(item, index) in approverRoleName">
                                                <li :key="index" :class="{roleSelection:index == currentIndex}" @click="obtainPersonnel(index)">
                                                    <i class="iconfont iconminsuzhuguanli"></i>
                                                    <span>{{ item }}</span>
                                                </li>
                                            </template>
                                        </ul>
                                    </div>
                                    <div class="transContainer el_left">
                                        <div class="trans el_left">
                                            <div class="tit">
                                                待选人员
                                            </div>
                                            <div class="trans-con">
                                                <el-radio-group v-model="radioWaitMembers">
                                                    <template v-for="(item, index) in waitMembersData">
                                                        <el-radio
                                                            :label="item.user_id"
                                                            :key="index"
                                                        >
                                                            {{ item.user_name }}
                                                        </el-radio>
                                                    </template>
                                                </el-radio-group>
                                            </div>
                                        </div>
                                        <div class="el_left trans-arrow">
                                            <div class="buttons">
                                                <span class="button-item" @click="transRight">
                                                    <i class="iconfont iconjiantouyou"></i>
                                                </span>
                                                <span class="button-item" @click="transLeft">
                                                    <i class="iconfont iconjiantouzuo"></i>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="trans el_left">
                                            <div class="tit">
                                                已选人员
                                            </div>
                                            <div class="trans-con">
                                                <el-radio-group v-model="radioChosedMembers">
                                                    <template v-for="(item, index) in chosedMembersData">
                                                        <el-radio
                                                            :label="item.user_id"
                                                            :key="index"
                                                        >
                                                            {{ item.user_name }}
                                                        </el-radio>
                                                    </template>
                                                </el-radio-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="fixedPersonnel" v-else>
                            <template v-for="(item, index) in approverRoleName">
                                <div :key="index">
                                    <img src="./../../../assets/images/sale/head_portrait2.png" alt="">
                                    <span>{{ item }}</span>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
        </div>
        <footer>
            <el-button type="primary" @click="selectionNode">
                确 定
            </el-button>
            <el-button @click="handleClose">
                取 消
            </el-button>
        </footer>
    </div>
</template>

<script>
export default {
    name: 'selection-node-new',
    components: {},
    props: {
        isFreeSubmission: {
            type: [Boolean],
        },
        submitLinkData: {
            type: [Array, Object, String, Number ],
        },
        businessInstanceId: {
            type: [String],
        },
        currentBusinessProcess: {
            type: [Object],
        },
    },
    data() {
        return {
            loading: false,
            businessPhaseId: '',
            // 部门类型
            deptType: null,
            // 环节数据集合
            nodeData: [],
            // 会签节点所有子节点数据
            countersignNodeData_all: [],
            // 会签节点当前显示子节点数据
            countersignNodeData: [],
            // 当前选中会签子节点下标
            countersignNodeIndex: null,
            // 会签节点子节点分页下标
            countersignNodeNavIndex: null,
            // 当前选择环节下标
            currentNode: 0,
            // 当前环节类型
            nodeType: 0,
            // 当前环节审批人类别
            nodeApproverCategory: 0,
            // 当前环节id
            currentNodeId: '',
            // 当前环节数据
            linkData: {},
            // 是否是第一环节
            IsFirstPhase: false,
            // 环节审批人
            HandledUsers: [],
            // 是否允许修改办理人
            isAllowEditApprover: false,
            // 环节审批角色id
            approverRoleId: [],
            // 环节审批角色name
            approverRoleName: [],
            // 选择环节返回数据
            nodeReturnData: {
                nodeType: 0,
                nodeData: {},
                IsCrossHierarchy: false,
                NextPhsaeId: '',
                NextApproverIds: '',
                NextApproverNames: '',
            },
            // 当前角色下标
            currentIndex: 0,
            // 待选-人员
            waitMembersData: [],
            // 待选-已选人员（单选）
            radioWaitMembers: '',
            // 待选-全选 
            checkWaitAll: false,
            // 已选-人员
            chosedMembersData: [],
            // 已选-已选人员（单选）
            radioChosedMembers: '',
            // 已选-全选 
            checkChosedAll: false,
            // 查询条件
            queryCriteria: '',
            // 退回
            isBack: null,
            // 人员是否按部门过滤
            isDeptFilter: false,
            // 部门类型
            deptFilterType: '',
        };
    },
    computed: {},
    watch: {
        isFreeSubmission(newVal) {
            this.isFree = newVal;
            // 初始化页面
            this.init();
        },
    },
    created() {
        this.isFree = this.isFreeSubmission;
        // 初始化页面
        this.init();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 初始化页面
        init() {
            this.nodeData = [];
            if (Object.keys(this.currentBusinessProcess).length > 0) {
                this.businessPhaseId = this.currentBusinessProcess.BusinessPhaseId;
                // 人员是否按部门过滤
                this.isDeptFilter = this.currentBusinessProcess.SubmitPhaseModel?.IsDeptFilter;
                // 部门类型
                this.deptFilterType = this.currentBusinessProcess.SubmitPhaseModel?.DeptFilterType;
            }
            if (Object.keys(this.submitLinkData).length > 0) {
                // 处理环节数据
                const processLinkData = JSON.parse(JSON.stringify(this.submitLinkData));
                this.processingLinkData(processLinkData);
            } else {
                this.loading = true;
                // 获取节点数据
                this.gitNodeData();
            }
        },
        // 获取节点数据 
        gitNodeData() {
            let getUrl = '';
            if (this.isFree) {
                getUrl = `/interfaceApi/basicplatform/simpleflow/processes/phases_other/new/${this.businessPhaseId}`;
            } else {
                getUrl = `/interfaceApi/basicplatform/simpleflow/processes/phases/new/${this.businessPhaseId}`;
            }
            this.$axios
                .get(getUrl)
                .then(res => {
                    // 处理环节数据
                    this.processingLinkData(res);
                })
                .catch(error => {
                    this.loading = false;
                    this.$message.error(error.ErrorCode.Message);
                });
        },
        // 处理环节数据
        processingLinkData(data) {
            if ((data || []).length < 1) {
                this.loading = false;
                return;
            }
            data.forEach(item => {
                item.data.forEach(k => {
                    this.dataChange_array(k);
                });
            });
            // 环节数据
            this.nodeData = data;
            // 环节类型
            this.nodeType = this.nodeData[0].node_type;
            const row = this.nodeData[0].data[0];
            // 部门类型
            this.deptType = row.DeptType || '';
            // 是否是退回
            this.isBack = this.nodeData[0].is_back;
            // 当前环节审批人类别
            this.nodeApproverCategory = row.ApproverType;
            // 当前环节id
            this.currentNodeId = row.BusinessPhaseId;
            // 是否允许修改办理人;
            this.isAllowEditApprover = row.IsAllowEditApprover;
            // 是否是第一环节
            this.IsFirstPhase = row.IsFirstPhase;
            // 环节审批人
            this.HandledUsers = row.HandledUsers;

            // 默认返回值
            this.nodeReturnData.IsCrossHierarchy = row.IsCrossHierarchy;
            this.nodeReturnData.NextPhsaeId = this.currentNodeId;
            this.nodeReturnData.NextApproverIds = this.dataChange_obj(row.ApproverId);
            this.nodeReturnData.NextApproverNames = this.dataChange_obj(row.ApproverName);
            if (this.nodeType === 3) {
                // 会签节点数据
                this.countersignNodeHandle(data[0].data);
                this.countersignNodeIndex = 0;
                // 当前环节数据
                this.linkData = data[0].data[0];
            }
            if (row.IsCrossHierarchy !== true) {
                if (this.isBack) {
                    this.filterData_back(row);
                } else {
                // 过滤审批人类别数据
                    this.filterData(row);
                }
            }
            this.loading = false;
        },
        // 选择节点
        selectNode(index, row, type) {
            this.waitMembersData = [];
            this.chosedMembersData = [];
            if (type === 'commonNode') {
                this.currentNode = index;
                this.countersignNodeIndex = 0;
                // 是否是退回
                this.isBack = row.is_back;
                // 环节类型
                this.nodeType = row.node_type;
                if (row.node_type === 3) {
                    // 会签节点数据
                    this.countersignNodeHandle(row.data);
                }
                if (!row.data[0].ApproverName) {
                    row.data[0].ApproverName = [];
                }
                if (!row.data[0].ApproverId) {
                    row.data[0].ApproverId = [];
                }
                // 当前环节数据
                this.linkData = row.data[0];
                this.selectNodeAssignment(row.data[0]);
            } else if (type === 'countersignatureNode') {
                this.countersignNodeIndex = index;
                // this.countersignNodeData[index].ApproverName = [];
                // 环节类型
                this.nodeType = row.PhaseType;
                if ((row.ApproverName || []).length === 0) {
                    row.ApproverName = [];
                }
                if ((row.ApproverId || []).length === 0) {
                    row.ApproverId = [];
                }
                // 当前环节数据
                this.linkData = row;
                this.selectNodeAssignment(row);
            }
        },
        // 选择节点赋值
        selectNodeAssignment(data) {
            this.approverRoleId = [];
            this.approverRoleName = [];
            this.chosedMembersData = [];
            this.nodeReturnData.NextApproverIds = '';
            this.nodeReturnData.NextApproverNames = '';
            // 当前环节审批人类别
            this.nodeApproverCategory = data.ApproverType;
            // 是否是跨级审批
            this.nodeReturnData.IsCrossHierarchy = data.IsCrossHierarchy;
            // 当前环节id
            this.currentNodeId = data.BusinessPhaseId;
            // 是否允许修改办理人;
            this.isAllowEditApprover = data.IsAllowEditApprover;
            // 是否是第一环节
            this.IsFirstPhase = data.IsFirstPhase;
            // 环节审批人
            this.HandledUsers = data.HandledUsers;
            // 部门类型
            this.deptType = data.DeptType || '';

            if (data.IsCrossHierarchy !== true) {
                // 过滤审批人类别数据
                if (this.isBack) {
                    this.filterData_back(data);
                } else {
                    this.filterData(data);
                }
            }
        },

        // 获取角色下人员
        obtainPersonnel(index, data) {
            this.chosedMembersData = [];
            this.currentIndex = index;
            const roleid = this.approverRoleId[index];
            const parameter = `businessInstanceId=${this.businessInstanceId}&roleId=${roleid}&deptType=${this.deptType}`;
            this.$axios
                .get(`/interfaceApi/basicplatform/simpleflow/processes/getphaseroleuser?${parameter}`)
                .then(res => {
                    this.loading = false;
                    this.waitMembersData = res;
                    if (data && (data.ApproverId || []).length > 0 && data.ApproverType !== 1) {
                        const chosedMembersData = this.waitMembersData.filter(item => item.user_id === data.ApproverId[0])[0];
                        this.radioWaitMembers = chosedMembersData.user_id;
                        this.radioChosedMembers = chosedMembersData.user_id;
                        this.chosedMembersData.push(chosedMembersData);
                    } else {
                        this.filteringData(this.waitMembersData);
                    }
                })
                .catch(error => {
                    this.loading = false;
                    this.$message.error(error.ErrorCode.Message);
                });
        },

        // 过滤审批人类别数据
        filterData(data) {
            if (this.nodeApproverCategory === 1) {
                // 默认第一个环节id赋值
                if (data.ApproverId) {
                    this.approverRoleId.push(...data.ApproverId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverName) {
                    this.approverRoleName.push(...data.ApproverName);
                }
                this.loading = false;
            } else if (this.nodeApproverCategory === 2) {
                // 默认第一个环节id赋值
                if (data.ApproverRoleId) {
                    this.approverRoleId.push(...data.ApproverRoleId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverRoleName) {
                    this.approverRoleName.push(...data.ApproverRoleName);
                }

                // 默认拉取第一个角色下人员
                this.obtainPersonnel(0, data);
            }
        },
        // 过滤审批人类别数据-已审环节[自由提交选择已提交环节]
        filterData_back(data) {
            if (data.HandledUsers?.length > 0) {
                const row = data.HandledUsers[data.HandledUsers.length - 1];
                this.approverRoleId.push(row.ApproverName);
                this.approverRoleName.push(row.ApproverName);
                this.chosedMembersData.push({
                    user_id: row.ApproverId,
                    user_name: row.ApproverName,
                });
            } else if (this.nodeApproverCategory === 1) {
                this.approverRoleId.push(...data.ApproverId);
                this.approverRoleName.push(...data.ApproverName);
                this.loading = false;
            } else if (this.nodeApproverCategory === 2) {
                // 默认第一个环节id赋值
                if (data.ApproverRoleId) {
                    this.approverRoleId.push(...data.ApproverRoleId);
                }
                // 默认第一个环节名称赋值
                if (data.ApproverRoleName) {
                    this.approverRoleName.push(...data.ApproverRoleName);
                }
                // 默认拉取第一个角色下人员
                this.obtainPersonnel(0, data);
            }
        },

        // 条件查询当前角色下人员
        query() {
            this.loading = true;
            const queryResults = [];
            if (this.queryCriteria !== '') {
                this.waitMembersData.forEach(item => {
                    if (item.user_name.indexOf(this.queryCriteria) !== -1) {
                        queryResults.push(item);
                    }
                });
                this.waitMembersData = queryResults;
                this.filteringData(this.waitMembersData);
            } else {
                this.obtainPersonnel(0);
            }
        },
        // 过滤数据，如果只有一条直接选中
        filteringData(data) {
            this.chosedMembersData = [];
            this.radioWaitMembers = '';
            this.radioChosedMembers = '';
            if (data.length === 1) {
                this.radioWaitMembers = data[0].user_id;
                this.radioChosedMembers = data[0].user_id;
                this.chosedMembersData = data;
                if (this.nodeType === 3) {
                    const new_ApproverName = data.map(item => item.user_name);
                    const new_ApproverId = data.map(item => item.user_id);

                    this.countersignNodeData[this.countersignNodeIndex].ApproverName = [];
                    this.countersignNodeData[this.countersignNodeIndex].ApproverId = [];
                    this.countersignNodeData_all[this.countersignNodeIndex].ApproverName = [];
                    this.countersignNodeData_all[this.countersignNodeIndex].ApproverId = [];

                    this.countersignNodeData[this.countersignNodeIndex].ApproverName.push(...new_ApproverName);
                    this.countersignNodeData[this.countersignNodeIndex].ApproverId.push(...new_ApproverId);
                    this.countersignNodeData_all[this.countersignNodeIndex].ApproverName.push(...new_ApproverName);
                    this.countersignNodeData_all[this.countersignNodeIndex].ApproverId.push(...new_ApproverId);
                }
            }
            this.loading = false;
        },
        // 向右选取
        transRight() {
            this.chosedMembersData = [];
            this.linkData.ApproverName = [];
            this.linkData.ApproverId = [];
            if ((this.radioWaitMembers || '') !== '') {
                const row = this.waitMembersData.filter(item => item.user_id === this.radioWaitMembers)[0];
                this.chosedMembersData.push(row);
                this.linkData.ApproverName.push(row.user_name);
                this.linkData.ApproverId.push(row.user_id);
                this.countersignNodeData[this.countersignNodeIndex] = this.linkData;
                const newIndex = this.countersignNodeData_all.findIndex(item => item.BusinessPhaseId === this.linkData.BusinessPhaseId);
                if (newIndex > -1) {
                    this.countersignNodeData_all[newIndex] = this.linkData;
                }
            } else {
                this.$message({
                    message: '请先选择人员',
                    type: 'warning',
                });
            }
        },
        // 向左选取,删除已选中
        transLeft() {
            this.chosedMembersData = [];
            this.linkData.ApproverName = [];
            this.linkData.ApproverId = [];
            this.countersignNodeData[this.countersignNodeIndex] = this.linkData;
            const newIndex = this.countersignNodeData_all.findIndex(item => item.BusinessPhaseId === this.linkData.BusinessPhaseId);
            if (newIndex > -1) {
                this.countersignNodeData_all[newIndex] = this.linkData;
            }
        },
        // 数组对象转字符串
        dataChange_obj(data) {
            let arrayData = [];
            if (Array.isArray(data)) {
                arrayData = data;
            } else {
                arrayData.push(data);
            }
            let newData = '';
            arrayData.forEach((item, index) => {
                if (index !== arrayData.length - 1) {
                    newData += item + ',';
                } else {
                    newData += item;
                }
            });
            return newData;
        },
        // 数组字符串转对象
        dataChange_array(data) {
            // 审批人id
            if (data.ApproverId) {
                data.ApproverId = data.ApproverId.split(',');
            }
            // 审批人name
            if (data.ApproverName) {
                data.ApproverName = data.ApproverName.split(',');
            }
            // 审批角色id
            if (data.ApproverRoleId) {
                data.ApproverRoleId = data.ApproverRoleId.split(',');
            }
            // 审批角色name
            if (data.ApproverRoleName) {
                data.ApproverRoleName = data.ApproverRoleName.split(',');
            }
        },
        // 确认选择节点
        // eslint-disable-next-line complexity
        selectionNode() {
            // 当前环节类型
            this.nodeReturnData.nodeType = this.nodeType;
            this.nodeReturnData.isBack = this.isBack;
            if (this.IsFirstPhase) {
                this.nodeReturnData.NextApproverIds = this.HandledUsers[0].ApproverId;
                this.nodeReturnData.NextApproverNames = this.HandledUsers[0].ApproverName;
            }
            if (this.nodeType === 3) { // 会签节点提交
                let isCanSubmit = true;
                const currentlySelectedNodeData = [];
                for (let i = 0; i < this.countersignNodeData_all.length; i++) {
                    const item = this.countersignNodeData_all[i];
                    if (item.IsRequired === 1) {
                        if ((item.ApproverId || []).length === 0 || (item.ApproverName || []).length === 0) {
                            isCanSubmit = false;
                            this.$message({
                                message: `环节【${item.BusinessPhaseName}】为必选环节！`,
                                type: 'warning',
                            });
                            break;
                        }
                    }
                    if ((item.ApproverId || []).length > 0 && (item.ApproverName || []).length > 0) {
                        currentlySelectedNodeData.push({
                            NextPhsaeId: item.BusinessPhaseId,
                            NextApproverIds: this.dataChange_obj(item.ApproverId),
                            NextApproverNames: this.dataChange_obj(item.ApproverName),
                        });
                    }
                }
                if (!isCanSubmit) {
                    return;
                }
                this.nodeReturnData.NextPhsaeId = '';
                this.nodeReturnData.NextApproverIds = '';
                this.nodeReturnData.NextApproverNames = '';
                this.nodeReturnData.isAllowEditApprover = true;
                // 当前环节数据
                this.nodeReturnData.nodeData = currentlySelectedNodeData;
            } else if (this.nodeApproverCategory === 1 || this.nodeReturnData.IsCrossHierarchy === true) {
                this.nodeReturnData.NextPhsaeId = this.currentNodeId;
                if ((this.approverRoleId || []).length > 0) {
                    this.nodeReturnData.NextApproverIds = this.dataChange_obj(this.approverRoleId[0]);
                }
                if ((this.approverRoleName || []).length > 0) {
                    this.nodeReturnData.NextApproverNames = this.dataChange_obj(this.approverRoleName[0]);
                }
            } else if (this.nodeApproverCategory === 2) {
                if (this.chosedMembersData.length > 0) {
                    if (this.isAllowEditApprover) {
                        // 选择环节返回数据
                        this.nodeReturnData.NextPhsaeId = this.currentNodeId;
                        this.nodeReturnData.NextApproverIds = this.dataChange_obj(this.chosedMembersData[0].user_id);
                        this.nodeReturnData.NextApproverNames = this.dataChange_obj(this.chosedMembersData[0].user_name);
                    } else {
                        this.nodeReturnData.NextPhsaeId = this.currentNodeId;
                        this.nodeReturnData.NextApproverIds = null;
                        this.nodeReturnData.NextApproverNames = null;
                        this.nodeReturnData.isAllowEditApprover = false;
                    }
                } else {
                    this.$message.error('请选择人员！');
                    return;
                }
            }
            this.$emit('selectionNodeCallback', this.nodeReturnData);
        },
        // 取消选择节点
        handleClose() {
            this.$emit('deselected');
        },
        // 会签环节子节点分页处理
        countersignNodeHandle(data) {
            data.forEach(item => {
                if (!item.ApproverName) {
                    item.ApproverName = [];
                }
                if (!item.ApproverId) {
                    item.ApproverId = [];
                }
            });
            this.countersignNodeData_all = JSON.parse(JSON.stringify(data));
            this.countersignNodeNavIndex = 0;
            if (data.length <= 3) {
                this.countersignNodeData = data;
            } else {
                const start = this.countersignNodeNavIndex;
                const end = this.countersignNodeNavIndex + 3;
                this.countersignNodeData = this.countersignNodeData_all.slice(start, end);
            }
        },
        countersignNode_left() {
            this.countersignNodeIndex = 0;
            this.countersignNodeNavIndex--;
            if (this.countersignNodeNavIndex < 0) {
                this.countersignNodeNavIndex = 0;
            }
            let start = this.countersignNodeNavIndex * 3;
            if (start < 0) {
                start = 0;
            }
            const end = start + 3;
            this.countersignNodeData = this.countersignNodeData_all.slice(start, end);

            this.linkData = this.countersignNodeData[0];
            this.selectNodeAssignment(this.countersignNodeData[0]);
        },
        countersignNode_right() {
            this.countersignNodeIndex = 0;
            const listLength = this.countersignNodeData_all.length;
            const new_index = Math.ceil(listLength / 3) - 1;
            this.countersignNodeNavIndex++;
            if (this.countersignNodeNavIndex > new_index) {
                this.countersignNodeNavIndex = new_index;
            }
            const start = this.countersignNodeNavIndex * 3;
            let end = start + 3;
            if (end > listLength) {
                end = listLength;
            }
            this.countersignNodeData = this.countersignNodeData_all.slice(start, end);

            this.linkData = this.countersignNodeData[0];
            this.selectNodeAssignment(this.countersignNodeData[0]);
        },
    },
};
</script>
<style lang="stylus" scoped>
.selectionNode_new
    width 1000px
    height 700px
    .selectionNodeContent
        height 600px
        display flex
        .processNode
            width 220px
            height 100%
            padding 20px
            overflow-x hidden
            overflow-y auto
            border-right 4px solid #F0F0F0
            h5
                font-size 16px
                line-height 16px
                padding-left 10px
                color #333333
                border-left 4px solid #979EA7
            ul
                li
                    height 80px
                    margin-top 20px
                    border 2px solid #91AFB2
                    border-left 4px solid #21BDCC
                    position relative
                    padding-left 10px
                    &:before,
                    &:after
                        display none
                    &:before
                        content ''
                        width 40px
                        height 40px
                        background url(./../../../assets/images/sale/pitch.png)
                        background-size 100% 100%
                        position absolute
                        right 0
                        top 0
                    &:after
                        content ''
                        width 8px
                        height 17px
                        background url(./../../../assets/images/sale/arrow.png)
                        background-size 100% 100%
                        position absolute
                        right -12px
                        top 50%
                        margin-top - 8px
                    &.countersignatureNode
                        border-color #C0B4A1
                        border-left-colr #F79400
                        span
                            background #F79400
                        p
                            color #A68D67
                    &.active
                        border 4px solid #5588F1
                        border-left 8px solid #5588F1
                        box-shadow 0px 0px 5px rgba(0,0,0,0.35)
                        &:before,
                        &:after
                            display block
                        span
                            background linear-gradient(90deg, #55A7FE 0%, #3E79C5 100%)
                        p
                            color #5588F1
                            line-height 27px
                            font-weight bold
                    span
                        display inline-block
                        height 20px
                        font-size 12px
                        line-height 20px
                        color #fff
                        background #21BDCC
                        border-radius 10px
                        padding 0 10px
                        margin 10px 0
                        &.isApproved
                            background linear-gradient(90deg, #55A7FE 0%, #3E79C5 100%)
                            margin-left 10px
                        i
                            font-size 14px
                    p
                        font-size 18px
                        color #333333
        .linkPersonnel
            width calc(100% - 220px)
            height 100%
            position initial
            box-shadow none
            padding 0 20px 20px 20px
            &.isCountersignatureNode
                .personnel
                    height 465px
            .link
                height calc(100% - 465px)
                .btns
                    padding 10px 0
                    text-align right
                    .el-button
                        width 16px
                        height 16px
                        padding 0
                        line-height 1
                        font-size 12px
                        text-align center
                .linkBox
                    width 100%
                    height 80px
                    overflow hidden
                    ul
                        display flex
                        li
                            flex-shrink 0
                            width calc((100% - 40px)/3)
                            margin-right 20px
                            height 80px
                            margin-right 20px
                            &:last-child
                                margin-right 0
                            &.active
                                h3
                                    border 3px solid #5588F1
                                    color #5588F1
                                    &:before
                                        background url(./../../../assets/images/sale/pitch.png)
                                p
                                    border-color #5588F1
                                    color #5588F1
                                    background #F7FAFF
                                    span
                                        border-color #D3E0FA
                            h3,p
                                padding-left 20px
                                line-height 36px
                                box-sizing border-box
                                height 40px
                            h3
                                border 1px solid #9BB1CF
                                font-size 16px
                                color #333333
                                padding-left 20px
                                position relative
                                display flex
                                &:before
                                    content ''
                                    width 36px
                                    height 36px
                                    background url(./../../../assets/images/sale/pitch_off.png)
                                    background-size 100%
                                    position absolute
                                    top 0
                                    right 0
                                i
                                    font-size 20px
                                    color red
                            p
                                border 1px dashed #9BB1CF
                                border-top none
                                font-size 12px
                                color #666666
                                display flex
                                align-items center
                                padding-right 10px
                                white-space nowrap
                                span
                                    border 1px solid #E9E8E8
                                    height 18px
                                    line-height 16px
                                    padding 0 5px
                                    margin-right 10px
                                    font-size 12px
            .personnel
                height 100%
                .choseMembers
                    height 100%
                    overflow hidden
                    .contant
                        height 100%
                        padding 20px 0 0 0
                        .search
                            width 100%
                            height 40px
                            position relative
                            margin-bottom 15px
                            &:before
                                position absolute
                                right 10px
                                font-size 20px
                                top 0
                                color #BBBBBB
                                z-index 2
                                line-height 36px
                        .createTeamCon
                            overflow hidden
                            height calc(100% - 55px)
                            .role
                                width 212px
                                height 100%
                                border 1px solid #D7D7D7
                                margin-right 37px
                                .tit
                                    height 34px
                                    line-height 34px
                                    background #ECF1F6
                                    margin 0
                                    padding-left 15px
                                    -webkit-box-sizing border-box
                                    box-sizing border-box
                                    color #000
                                    font-size 16px
                                ul
                                    height calc(100% - 34px)
                                    overflow-x hidden
                                    overflow-y auto
                                    li
                                        cursor pointer
                                        font-size 14px
                                        line-height 34px
                                        padding-left 20px
                                        border-bottom 1px solid #F0F0F0
                                        i
                                            color #979EA7
                                            margin-right 10px
                                        span
                                            color #333333
                                        &.roleSelection
                                            i,
                                            span
                                                color #5588F1
                                        &:hover
                                            background #FBFBFB
                            .transContainer
                                width calc(100% - 250px)
                                height 100%
                                .trans
                                    height 100%
                                    width calc((100% - 37px)/2)
                                    border 1px solid #D7D7D7
                                    .tit
                                        height 34px
                                        line-height 34px
                                        background #ECF1F6
                                        margin 0
                                        padding-left 15px
                                        -webkit-box-sizing border-box
                                        box-sizing border-box
                                        color #000
                                        font-size 16px
                                        .el-checkbox__input
                                            margin-top -2px
                                        .el-checkbox__label
                                            color #000
                                            font-size 16px
                                .trans-arrow
                                    width 37px
                                    height 100%
                                    padding-top 35%
                                    .buttons
                                        display inline-block
                                        vertical-align middle
                                        .button-item
                                            width 27px
                                            height 27px
                                            border 1px solid #dee1e7
                                            background #f5f7fa
                                            text-align center
                                            border-radius 50%
                                            display block
                                            margin 0 5px
                                            display inline-block
                                            margin-bottom 10px
                                            cursor pointer
                                            color #cbcfd6
                                            text-align center
                                            i
                                                font-size 16px
                                                line-height 27px
                                            &:nth-of-type(1)
                                                &:hover
                                                    background #409eff
                                                    border 1px solid #409eff
                                                    color #fff
                                            &:nth-of-type(2)
                                                &:hover
                                                    background #D40004
                                                    border 1px solid #D40004
                                                    color #fff
                                .trans-con
                                    height calc(100% - 34px)
                                    overflow-y auto
                                    overflow-x hidden
                                    width 100%
                                    .el-radio-group
                                    .el-checkbox-group
                                        font-size 14px
                                        line-height 34px
                                        padding-left 15px
                                        .el-radio__input
                                            margin-top -2px
                        .transPagination
                            text-align center
                            >div
                                display inline-block
                        .footer
                            display inline-block
                            width 100%
                            text-align center
                            margin-top 10px
                            button
                                padding 7px 9px
                .fixedPersonnel
                    width 100%
                    height 100%
                    display flex
                    align-items center
                    justify-content center
                    overflow-y auto
                    >div
                        width 200px
                        height 300px
                        border-top 6px solid #5588F1
                        box-shadow 0px 0px 8px rgba(85, 136, 241, 0.45)
                        text-align center
                        position relative
                        border-radius 2px
                        margin 0 40px
                        vertical-align top
                        flex-shrink 0
                        &:after
                            content ''
                            width 77px
                            height 30px
                            background url(./../../../assets/images/sale/select.png)
                            background-size 100% 100%
                            position absolute
                            top -9px
                            left 0
                        img
                            width 120px
                            height 120px
                            margin-top 40px
                            margin-bottom 30px
                            display inline-block
                        span
                            display block
                            width 100%
                            font-size 25px
                            color #333333
                            padding 0 30px
    footer
        text-align center
        height 100px
        border-top 4px solid #F0F0F0
        padding-top 26px
        button
            width 160px
            height 40px
            margin 0 30px
            padding 0
</style>
